module.exports = __webpack_public_path__ + "img/Bet 1.b8bd77d5.png";